import mixpanel from 'mixpanel-browser'
import { IS_DEVELOPMENT } from './shared/constants/environments'

if (!IS_DEVELOPMENT) {
  mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN!, { debug: false })
}
